import { observer } from "mobx-react";
import React from "react";
import {
  PendingAdviserNameSummary,
  Props as PendingNameSummaryProps
} from "../adviserNameSummary/pendingAdviserNameSummary";
import styles from "./agentBox.css";

export const PendingAgentBox = observer((props: PendingNameSummaryProps) => {
  return (
    <div className={styles.container}>
      <PendingAdviserNameSummary {...props} />
    </div>
  );
});
